import { Typography } from "@mui/material";
import { Link } from "react-router-dom";
import { trimZeros } from "src/utils/genericFunctions";

const LinkItem = ({
  rowData,
  id,
  navLink
}: {
  rowData: any;
  id: string | number;
  navLink: string;
}) => {
  return (
    <Link to={navLink} target="_blank" aria-label={"product"}>
      <Typography variant="subtitle2" color={"primary.main"}>
        {trimZeros(rowData[id])}
      </Typography>
    </Link>
  );
};

export default LinkItem;
